import { createSlice } from '@reduxjs/toolkit';
import {
    getSettings,
    updateSettings,
    updateOrganisationalImage as updateOrganisationalImageApi,
    getCurrentSubscription,
    getSubscriptionList,
    updateDirectLinksStatus as updateDirectLinksStatusApi,
    updateDefaultQuizLevel as updateDefaultQuizLevelApi,
    updateAutoIncludeCourseReady as updateAutoIncludeCourseReadyApi
} from 'api/settings';
import { dispatch } from '../index';

const initialState = {
    clientSettings: {},
    subscription: {
        list: [],
        total: 0,
        isFetching: true,
        params: {
            query: '',
            pageNo: 1,
            perPage: 10,
            sortBy: 'createdAt',
            sortDirection: 'DESC'
        },
        currentPlan: {
            data: {},
            isFetching: true
        }
    }
};

const slice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setClientSettings(state, action) {
            state.clientSettings = action.payload.data;
        },
        // SET Params dynamically base on key
        setParams(state, action) {
            const { params, key } = action.payload;
            const item = state[key];
            if (item) {
                item.params = params;
            }
        },
        // SET IsFetching dynamically base on key
        setIsFetching(state, action) {
            const { status, key } = action.payload;
            const item = state[key];
            if (item) {
                item.isFetching = status;
            }
        },
        // SET List dynamically base on key
        setList(state, action) {
            const { data, isUpdateTotalCount, key } = action.payload;
            const { list = [], summary } = data;
            const item = state[key];
            if (item) {
                item.list = list;
                // we will update the count
                if ((item.total === 0 || isUpdateTotalCount) && summary) {
                    const { total = 0 } = summary;
                    item.total = total;
                }
            }
        },
        // SET Current Plan for Subscription
        setCurrentPlan(state, action) {
            const item = state.subscription;
            if (item) {
                const { data = {} } = action.payload;
                item.currentPlan.data = data;
            }
        },
        // SET Current Plan is Fetching for Subscription
        setCurrentPlanIsFetching(state, action) {
            const item = state.subscription;
            if (item) {
                item.currentPlan.isFetching = action.payload;
            }
        }
    }
});

export const { setClientSettings, setParams, setIsFetching, setCurrentPlanIsFetching, setList } = slice.actions;
export default slice.reducer;

export const updateOrganisationalSettings = (data) => async (dispatch) => {
    await updateSettings(data);
    const response = await getSettings();
    dispatch(setClientSettings({ data: response?.data }));
};

export const updateDefaultQuizLevel = (data) => async (dispatch) => {
    await updateDefaultQuizLevelApi(data);
    const response = await getSettings();
    dispatch(setClientSettings({ data: response?.data }));
};

export const updateAutoIncludeCourseReady = (data) => async (dispatch) => {
    await updateAutoIncludeCourseReadyApi(data);
    const response = await getSettings();
    dispatch(setClientSettings({ data: response?.data }));
};

export const updateOrganisationalImage = (formData) => async (dispatch) => {
    await updateOrganisationalImageApi(formData);
    const response = await getSettings();
    dispatch(setClientSettings({ data: response?.data }));
};

export const updateDirectLinksStatus = (data) => async (dispatch) => {
    await updateDirectLinksStatusApi(data);
    const response = await getSettings();
    dispatch(setClientSettings({ data: response?.data }));
};

export function fetchSubscriptions(params, isUpdateTotalCount = false) {
    return async () => {
        const key = 'subscription';
        try {
            const result = await getSubscriptionList(params);
            dispatch(
                slice.actions.setList({
                    data: result?.data || [],
                    isUpdateTotalCount,
                    key
                })
            );
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setList({
                    data: [],
                    key
                })
            );
        }
    };
}

export function fetchCurrentPlan() {
    return async () => {
        try {
            const result = await getCurrentSubscription();
            dispatch(slice.actions.setCurrentPlan({ data: result?.data || {} }));
        } catch (error) {
            console.log('error', error);
            dispatch(slice.actions.setCurrentPlan({ data: {} }));
        }
    };
}

export function fetchSettings() {
    return async () => {
        try {
            const response = await getSettings();
            dispatch(slice.actions.setClientSettings(response || {}));
        } catch (error) {
            console.log('error', error);
            dispatch(slice.actions.setCurrentPlan({}));
        }
    };
}
